<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">
      {{ 'Settings::EightByEightIntegrationSourceName' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="username">
    <label for="username">{{ 'Settings::EightByEightIntegrationUsername' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="username"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="password">
    <label for="password">{{ 'Settings::EightByEightIntegrationPassword' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="password"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="apiKey">
    <label for="apiKey">{{ 'Settings::EightByEightIntegrationApiKey' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="apiKey"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="apiSecret">
    <label for="apiSecret">
      {{ 'Settings::EightByEightIntegrationApiSecret' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="apiSecret"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="region">
    <label for="region">{{ 'Settings::EightByEightIntegrationRegion' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="region" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="timeZone">
    <label for="timeZone">{{ 'Settings::EightByEightIntegrationTimeZone' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="timeZone"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="scimBaseUrl">
    <label for="scimBaseUrl">
      {{ 'Settings::EightByEightIntegrationScimBaseUrl' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="scimBaseUrl"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="scimToken">
    <label for="scimToken">
      {{ 'Settings::EightByEightIntegrationScimToken' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="scimToken"
      [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
      formControlName="value" />
  </div>
   <div class="form-group pt-2" formGroupName="migrationStartDate">
    <label for="migrationStartDate">
      {{ 'Settings::EightByEightIntegrationMigrationStartDate' | abpLocalization }}
    </label>
    <input
      type="text"
      placeholder="2023-01-31"
      class="form-control form-control-sm"
      id="migrationStartDate"
      formControlName="value" />
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
